import React from 'react';

function Contato() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Contato</h2>
      <p>Entre em contato conosco através do e-mail: contato@cineflixhistoria.com</p>
    </div>
  );
}

export default Contato;
